export const NEW = 'new';
export const ACCEPTED = 'accepted';
